import React, { useState, useEffect } from "react"
import styled from "styled-components"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"
import ResultCard from "@/containers/MoneyFortune/View/result/ResultCard"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Result() {
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "Jeff"
    })[0]

    setResultPageDate(resultfilter)
  }, [])

  return (
    <Wrapper>
      <MetaData
        title={`我的代表人物是 穩賺大哥 - 麻吉大哥`}
        description="身為商業鬼才的你，可以掌握任何投資機會，敏銳的嗅覺讓你在各領域都極可能獲得成功，十分懂得市場局勢與掌握投資節奏。"
        url={`https://www.kryptogo.com/money-fortune/Jeff`}
        image="https://i.ibb.co/BtKzfSw/OG-MaJi.webp"
      />
      <ResetCSS />
      <ResultCard
        key={resultPageData.roleID}
        name={resultPageData.name}
        AKA={resultPageData.AKA}
        chance={resultPageData.chance}
        saying={resultPageData.saying}
        summary={resultPageData.summary}
        analysis={resultPageData.analysis}
        investment={resultPageData.investment}
        befit={resultPageData.befit}
        img={resultPageData.img}
        type="share"
        GetAndShare={GetAndShare}
        API={GetAndShare.API}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
